module.exports = {"440309001":"观湖街道","440309002":"民治街道","440309003":"龙华街道","440309004":"大浪街道","440309005":"福城街道","440309006":"观澜街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440309.json
// module id = 1972
// module chunks = 0